const Legal = () => import(/* webpackChunkName: "Legal" */ "@/views/legal/Legal");
const Terms = () => import(/* webpackChunkName: "Legal Terms" */ "@/views/legal/LegalTerms");
const Privacy = () => import(/* webpackChunkName: "Legal Privacy" */ "@/views/legal/LegalPrivacy");

const legalRoutes = [
  {
    path: "legal",
    name: "Legal",
    redirect: {
      name: "Legal Terms"
    },
    component: Legal,
    children: [
      {
        path: "terms",
        name: "Legal Terms",
        component: Terms
      },
      {
        path: "privacy",
        name: "Legal Privacy",
        component: Privacy
      }
    ]
  }
];

export default legalRoutes;